import { create } from "zustand";
import { getMySubscription, getPlans } from "../api/subscriptions.api";

const useSubscriptionStore = create((set) => ({
  mySubscription: null,
  plans: [],
  loading: false,

  fetchMySubscription: async () => {
    set({ loading: true });
    try {
      const res = await getMySubscription();
      set({ mySubscription: res.data });
    } catch (err) {
      set({ mySubscription: null });
    } finally {
      set({ loading: false });
    }
  },

  fetchPlans: async () => {
    set({ loading: true });
    try {
      const res = await getPlans();
      set({ plans: res.data });
    } finally {
      set({ loading: false });
    }
  },

  // 2026-06-18 — clear subscription state. Called by auth.store on
  // sign-out / sign-in so the previous account's mySubscription does
  // not briefly flash on the new account's Subscriptions page.
  reset: () => set({
    mySubscription: null,
    plans: [],
    loading: false,
  }),
}));

export default useSubscriptionStore;
